import { Trophy } from 'lucide-react';
import { useState } from 'react';

interface Competition {
  title: string;
  objectives: string[];
}

const competitions: Competition[] = [
  {
    title: "IXS Europe (EDC)",
    objectives: [
      "Racing team, 4-6 phases",
      "4-8 rideri, clasări în top 20"
    ]
  },
  {
    title: "World Championship",
    objectives: [
      "4-5 rideri NH Velo",
      "Cel puțin o clasare în top 30"
    ]
  },
  {
    title: "European Championship",
    objectives: [
      "Echipa națională",
      "4-5 rideri NH Velo, calificări în finală",
      "Clasări în top 40"
    ]
  },
  {
    title: "CND & CRD",
    objectives: [
      "25-40 rideri NH Velo",
      "2-3 campioni naționali",
      "60% din toate locurile de podium"
    ]
  }
];

interface OrganizedEvent {
  year: string;
  events: string[];
}

const organizedEvents: OrganizedEvent[] = [
  {
    year: "Până în 2024",
    events: [
      "Am organizat de două ori campionatul național de DH",
      "Am organizat de 4 ori Cupa României la Downhill"
    ]
  },
  {
    year: "2025",
    events: [
      "2 etape de Cupă a României la Downhill - una în Azuga și una în Postavarul"
    ]
  }
];

export function CompetitionsSection() {
  const [activeTab, setActiveTab] = useState<'participari' | 'evenimente'>('participari');

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl font-bold text-center mb-4">Competiții</h2>
        <p className="text-xl text-gray-600 text-center mb-12">
          Performanțe și obiective în competițiile naționale și internaționale
        </p>

        <div className="flex justify-center gap-4 mb-12">
          <button
            onClick={() => setActiveTab('participari')}
            className={`px-6 py-3 rounded-lg font-semibold transition-colors ${
              activeTab === 'participari'
                ? 'bg-orange-500 text-white'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            Participări
          </button>
          <button
            onClick={() => setActiveTab('evenimente')}
            className={`px-6 py-3 rounded-lg font-semibold transition-colors ${
              activeTab === 'evenimente'
                ? 'bg-orange-500 text-white'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            Evenimente Organizate
          </button>
        </div>

        {activeTab === 'participari' ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {competitions.map((competition, index) => (
              <div key={index} className="bg-gray-50 rounded-xl p-6 shadow-sm">
                <div className="flex items-start gap-4">
                  <div className="bg-orange-100 p-3 rounded-lg">
                    <Trophy className="w-6 h-6 text-orange-500" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-4">{competition.title}</h3>
                    <ul className="space-y-3">
                      {competition.objectives.map((objective, idx) => (
                        <li key={idx} className="flex items-center gap-2">
                          <span className="text-orange-500">•</span>
                          {objective}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="bg-gray-50 rounded-xl p-8">
            {organizedEvents.map((event, index) => (
              <div key={index} className="mb-8 last:mb-0">
                <h3 className="text-xl font-bold mb-4">{event.year}</h3>
                <ul className="space-y-3">
                  {event.events.map((eventDesc, idx) => (
                    <li key={idx} className="flex items-center gap-2">
                      <span className="text-orange-500">•</span>
                      {eventDesc}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}